<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <h3>{{ 'price-settings.description' | translate }}</h3>
  <agr-table [config]="priceSettingsTableConfig" data-test="price-settings-table">
    <ng-container [ngTemplateOutlet]>
      <button>clear</button>
    </ng-container>
  </agr-table>
  <h3>{{ 'price-settings.product-description' | translate }}</h3>
  <div>
    <span class="text--small text--bold label"> {{ 'region' | translate }}: </span>
    <mat-select
      [hideSingleSelectionIndicator]="true"
      class="flex__child--auto spacing--margin-right text--small regionSelector"
      data-placeholder="{{ 'region' | translate }}"
      data-test="product-country-selector"
      (selectionChange)="changeRegionSelection($event)"
      [value]="selectedRegionId"
    >
      <mat-option *ngFor="let region of regions" [value]="region.id">
        {{ 'regions.' + region.id | translate }}
      </mat-option>
    </mat-select>
  </div>
</agr-form-dialog>
